import { render, staticRenderFns } from "./portalIdChange.vue?vue&type=template&id=a30d4530"
import script from "./portalIdChange.vue?vue&type=script&lang=js"
export * from "./portalIdChange.vue?vue&type=script&lang=js"
import style0 from "./portalIdChange.vue?vue&type=style&index=0&id=a30d4530&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a30d4530')) {
      api.createRecord('a30d4530', component.options)
    } else {
      api.reload('a30d4530', component.options)
    }
    module.hot.accept("./portalIdChange.vue?vue&type=template&id=a30d4530", function () {
      api.rerender('a30d4530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/csm/portalIdChange.vue"
export default component.exports